import { gql } from 'apollo-angular';

export const RemoveTeamDocument = gql`
  mutation removeTeam($id: Int!) {
    removeTeam(id: $id)
  }
`;
